/**
 * A tenant brand image that degrades gracefully: if the URL fails to load
 * (object deleted, public bucket misconfigured, offline) the `fallback` is
 * rendered instead of the browser's broken-image glyph. The failure is keyed
 * on `src`, so a replaced logo gets a fresh attempt.
 */

import React, { useState } from 'react';

interface Props {
  src: string;
  alt: string;
  className?: string;
  /** Rendered in place of the image once it has failed to load. */
  fallback: React.ReactNode;
}

export function CompanyBrandImage({ src, alt, className, fallback }: Props) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (failedSrc === src) return <>{fallback}</>;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      draggable={false}
      onError={() => setFailedSrc(src)}
    />
  );
}
